// hooks/useFileOperations.ts
import { useState } from "react";
import axios from "axios";
import { Endpoint } from "../../api/base";

export const useFileOperations = (case_id: string) => {
  const [loading, setLoading] = useState(false);

  const fetchFileBlob = async (fileName: string) => {
    const config = {
      document_name: fileName,
      file_no: case_id,
    };

    const response = await Endpoint.getFile(config);

    const pdfResponse = await axios(response.data.downloads[0].url, {
      method: "GET",
      responseType: "blob",
    });

    return new Blob([pdfResponse.data], { type: "application/pdf" });
  };

  const getFile = async (fileName: string) => {
    setLoading(true);
    try {
      const blob = await fetchFileBlob(fileName);
      const pdfUrl = URL.createObjectURL(blob);
      return pdfUrl;
    } catch (err) {
      console.error("Error fetching file:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const downloadFile = async (fileName: string) => {
    setLoading(true);
    try {
      const blob = await fetchFileBlob(fileName);
      const downloadUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error("Error downloading file:", err);
    } finally {
      setLoading(false);
    }
  };

  const openFileInNewTab = async (fileName: string, fileType: string) => {
    setLoading(true);
    try {
      const config = {
        document_name: fileName,
        file_no: case_id,
      };

      const response = await Endpoint.getFile(config);

      if (fileType !== "other") {
        const fileResponse = await axios(response.data.downloads[0].url, {
          method: "GET",
          responseType: "blob",
        });

        const file = new Blob([fileResponse.data], { type: fileType });
        window.open(URL.createObjectURL(file), "_blank")?.focus();
      } else {
        window.open(response.data.downloads[0].url, "_blank")?.focus();
      }
    } catch (err) {
      console.error("Error opening file:", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    getFile,
    downloadFile,
    openFileInNewTab,
  };
};
